import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VCard,
        { staticClass: "mx-auto mt-2 card-filters", attrs: { tile: "" } },
        [
          _c(VImg, {
            staticClass: "rounded primary",
            staticStyle: { position: "relative" },
            attrs: {
              height: "200",
              src: require("@/assets/banner_01.png"),
              "aspect-ratio": "2",
            },
          }),
          _c(
            VMenu,
            {
              attrs: { absolute: "", "offset-y": "", disabled: !_vm.edit },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        VAvatar,
                        _vm._g(
                          _vm._b(
                            {
                              class: !_vm.user.photoURL
                                ? "white--text font-weight-bold"
                                : "",
                              staticStyle: {
                                position: "absolute",
                                left: "0",
                                right: "0",
                                top: "150px",
                                "margin-left": "auto",
                                "margin-right": "auto",
                                "z-index": "0",
                              },
                              attrs: {
                                color: !_vm.user.photoURL ? "secondary" : "",
                                height: "120",
                                width: "120",
                              },
                              on: {
                                mouseover: function ($event) {
                                  _vm.isHovered = true
                                },
                                mouseleave: function ($event) {
                                  _vm.isHovered = false
                                },
                              },
                            },
                            "v-avatar",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          !_vm.user.photoURL
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.getUserInitials())),
                              ])
                            : _c(VImg, {
                                class: {
                                  hover_image: _vm.edit && _vm.isHovered,
                                },
                                attrs: { contain: "", src: _vm.user.photoURL },
                              }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.showMenu,
                callback: function ($$v) {
                  _vm.showMenu = $$v
                },
                expression: "showMenu",
              },
            },
            [
              _c(
                VList,
                [
                  _c(
                    VListItem,
                    { on: { click: _vm.onButtonUploadImageClick } },
                    [
                      _c(
                        VListItemIcon,
                        [_c(VIcon, [_vm._v(" cloud_upload ")])],
                        1
                      ),
                      _c(VListItemTitle, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("botones.boton_upload_image")) +
                            " "
                        ),
                      ]),
                      _c(VListItemContent, [
                        _c("input", {
                          ref: "uploader",
                          staticClass: "d-none",
                          attrs: { type: "file", accept: "image/*" },
                          on: { change: _vm.onFileChanged },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VTabs,
            {
              staticClass: "mt-10",
              attrs: { centered: "" },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.about_me")))]),
              _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.roles")))]),
              _c(VTab, [_vm._v("Historial de búsqueda")]),
            ],
            1
          ),
          _c(
            VTabsItems,
            {
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c(
                VTabItem,
                [
                  _c(
                    VCard,
                    {
                      staticClass: "mx-auto",
                      attrs: {
                        flat: "",
                        "max-width": "700",
                        tile: "",
                        loading: _vm.isLoadingProfile,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "progress",
                          fn: function () {
                            return [_c("base-loading-component")]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      !_vm.isLoadingProfile
                        ? _c(
                            VCardText,
                            [
                              _c(
                                VForm,
                                {
                                  ref: "form",
                                  staticClass: "mt-2",
                                  attrs: {
                                    "lazy-validation": "",
                                    readonly: !_vm.edit,
                                  },
                                  model: {
                                    value: _vm.valid,
                                    callback: function ($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid",
                                  },
                                },
                                [
                                  _c(
                                    VCol,
                                    {
                                      staticClass:
                                        "form-row row--dense fit_content mt-2",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _c(
                                                VIcon,
                                                { attrs: { left: "" } },
                                                [_vm._v("bx bxs-user")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "form_profile.display_name"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { attrs: { cols: "8" } },
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              outlined: _vm.edit,
                                              filled: !_vm.edit,
                                              "hide-details": "auto",
                                              dense: "",
                                              rules: _vm.rules.displayName,
                                              "max-length": "50",
                                              "min-length": "3",
                                              rounded: "",
                                              "append-icon": _vm.iconEdit,
                                            },
                                            on: {
                                              "click:append": function (
                                                $event
                                              ) {
                                                _vm.edit = !_vm.edit
                                              },
                                            },
                                            model: {
                                              value: _vm.user.displayName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.user,
                                                  "displayName",
                                                  $$v
                                                )
                                              },
                                              expression: "user.displayName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    {
                                      staticClass:
                                        "form-row row--dense fit_content mt-2",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _c(
                                                VIcon,
                                                { attrs: { left: "" } },
                                                [_vm._v("bx bxs-envelope")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("form_profile.email")
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { attrs: { cols: "8" } },
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              readonly: "",
                                              filled: "",
                                              "hide-details": "auto",
                                              dense: "",
                                              rounded: "",
                                            },
                                            model: {
                                              value: _vm.user.email,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.user, "email", $$v)
                                              },
                                              expression: "user.email",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    {
                                      staticClass:
                                        "form-row row--dense fit_content mt-2",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _c(
                                                VIcon,
                                                {
                                                  attrs: {
                                                    small: "",
                                                    left: "",
                                                  },
                                                },
                                                [_vm._v("fas fa-language")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "form_profile.default_language"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { attrs: { cols: "8" } },
                                        [
                                          _c(VSelect, {
                                            attrs: {
                                              outlined: _vm.edit,
                                              filled: !_vm.edit,
                                              "hide-details": "auto",
                                              dense: "",
                                              required: "",
                                              items: _vm.$i18n.locales,
                                              "item-text": "label",
                                              "item-value": "code",
                                              "menu-props": {
                                                top: false,
                                                offsetY: false,
                                              },
                                              rounded: "",
                                              "append-icon": "mdi-chevron-down",
                                            },
                                            on: {
                                              change: _vm.setLocale,
                                              "click:append": function (
                                                $event
                                              ) {
                                                _vm.edit = !_vm.edit
                                              },
                                            },
                                            model: {
                                              value: _vm.user.defaultLanguage,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.user,
                                                  "defaultLanguage",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "user.defaultLanguage",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    {
                                      staticClass:
                                        "form-row row--dense fit_content mt-2",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _c(
                                                VIcon,
                                                {
                                                  attrs: {
                                                    small: "",
                                                    left: "",
                                                  },
                                                },
                                                [_vm._v("fas fa-user-plus")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "form_profile.created"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { attrs: { cols: "8" } },
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              readonly: "",
                                              filled: "",
                                              "hide-details": "auto",
                                              dense: "",
                                              "max-length": "50",
                                              "min-length": "3",
                                              rounded: "",
                                            },
                                            model: {
                                              value: _vm.user.created,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.user,
                                                  "created",
                                                  $$v
                                                )
                                              },
                                              expression: "user.created",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    {
                                      staticClass:
                                        "form-row row--dense fit_content mt-2",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _c(
                                                VIcon,
                                                { attrs: { left: "" } },
                                                [_vm._v("mdi-login")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "form_profile.las_sign_in"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { attrs: { cols: "8" } },
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              readonly: "",
                                              filled: "",
                                              "hide-details": "auto",
                                              dense: "",
                                              "max-length": "50",
                                              "min-length": "3",
                                              rounded: "",
                                            },
                                            model: {
                                              value: _vm.user.lastSignIn,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.user,
                                                  "lastSignIn",
                                                  $$v
                                                )
                                              },
                                              expression: "user.lastSignIn",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isLoadingProfile
                        ? _c(
                            VCardActions,
                            { staticClass: "pt-1 pl-3 pr-6 pb-3" },
                            [
                              _vm._t("btnsLeft"),
                              _c(VSpacer),
                              _c(
                                VBtn,
                                {
                                  staticClass: "default mr-1",
                                  attrs: { outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.go(-1)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("btns.back")))]
                              ),
                              _vm.edit
                                ? _c(
                                    VBtn,
                                    {
                                      staticClass: "primary mr-1",
                                      attrs: {
                                        type: "submit",
                                        disabled: _vm.isUploadingImage,
                                        loading: _vm.isUpdatingProfile,
                                      },
                                      on: { click: _vm.onUpdateProfile },
                                    },
                                    [
                                      _c(
                                        VIcon,
                                        {
                                          staticClass: "mr-1",
                                          attrs: { small: "" },
                                        },
                                        [_vm._v("mdi-content-save")]
                                      ),
                                      _vm._v(" " + _vm._s(_vm.$t("btns.save"))),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(VTabItem, [_c("roles-component")], 1),
              _c(
                VTabItem,
                [
                  _c(
                    VCard,
                    {
                      staticClass: "mx-auto",
                      attrs: {
                        flat: "",
                        "max-width": "700",
                        tile: "",
                        loading: _vm.isLoadingProfile,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "progress",
                          fn: function () {
                            return [_c("base-loading-component")]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      !_vm.isLoadingProfile
                        ? _c(
                            VCardText,
                            [
                              _c(VDataTable, {
                                staticClass: "table-inca",
                                attrs: {
                                  items: _vm.searchs,
                                  headers: _vm.headers_history,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }